export default {
  seeAllType: {
    en: 'See all <span class="brand">{type}</span>',
  },
  seeAllFragrances: {
    en: 'See all&nbsp;<span class="brand">{slug}</span>&nbsp;products',
  },
  checkBestsellers: {
    en: 'Sorry, we didn\'t find anything. Check out our bestsellers.',
  },
}
